import { Permissions } from './permissions';
import { Filters } from './filtering';


export namespace Users {
    interface CommonCompanyUser {
        Uid: string;
        IndividualUid: string;
        FirstName: string;
        MiddleName: string;
        Surname: string;
        FullName: string;
        INN: string;
        Login: string;
        NotificationEmail: string;
        PhoneNumber: string;
        SignerType: 0 | 1 | 2;
        IsWarrantIssuer: boolean;
        IsWarrantRevoker: boolean;
        UserChangeStatusId: number;
        CreateDate: string;
    }
    export interface CompanyUser extends CommonCompanyUser {
        IsCompanyAdmin: boolean;
        IsDfaIssuer: boolean;
        IsDfaOwner: boolean;
        IsNominalHolder: boolean;
    }

    export interface CompanyNotifications {
        Uid: string;
        Name: string;
        Code: string;
        IsChecked: boolean;
        Members: string[];
    }

    export interface CompanyUserDetails extends CommonCompanyUser {
        NotificationEvents: CompanyNotifications[];
        Permissions: string[];
        ClientProfile: {
            Uid: string;
            ClientProfileType: string;
        };
    }

    export interface IdentityUser {
        UserName: string;
        Id: string;
        Permissions: Permissions.Permission[];
        PermissionGroups: Permissions.PermissionGroup[];
    }
}

export const usersFilters = {
    userName: <Filters.Filter>{
        api: ({ value }) => ({
            userName: value,
        }),
    },
};
